import React from 'react';
import { objectOf, array } from 'prop-types';
import styled from 'styled-components';
import delve from 'dlv';

import { withGroupContext } from 'context/groupContext';

import TrendIndicator from 'components/TrendIndicator/TrendIndicator';

const StyledHeader = styled('header')`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;

  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.base.Teal},
    ${({ theme }) => theme.base.TealSupport}
  );
`;

const KeenCorpIndex = styled('div')`
  padding: 3em;
  text-align: left;
`;

const Label = styled('h1')`
  font-size: 1em;
  font-weight: bold;
  margin: 0;
`;

const Number = styled('div')`
  display: flex;
`;

const IndexNumber = styled('span')`
  font-family: ${({ theme }) => theme.numbersFontFamily};
  font-style: italic;
  font-size: 7.5em;
  font-weight: 700;
  line-height: 1;
`;

const StyledTrendIndicator = styled(TrendIndicator)`
  margin-top: 1.1em;
  margin-left: 0.5em;
`;

function Header({ trendScores }) {
  const index = delve(trendScores, 'All.current');
  const trend = delve(trendScores, 'All.trend');

  return (
    <StyledHeader>
      <KeenCorpIndex>
        <Label>Latest KeenCorp Index</Label>
        <Number>
          <IndexNumber id="index-number">{index}</IndexNumber>
          <StyledTrendIndicator trend={trend} width={20} />
        </Number>
      </KeenCorpIndex>
    </StyledHeader>
  );
}

Header.propsTypes = {
  trendScores: objectOf(array).isRequired,
};

export default withGroupContext(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js